var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendationBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 506,
    height: 285,
    viewBox: "0 0 506 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.116 284.614C160.405 283.435 120.483 279.118 82.827 269.579C50.493 261.378 31.7537 246.919 20.5771 228.488C5.09673 202.764 -0.173532 176.219 0.00433464 149.271C0.00433464 116.179 7.64296 83.9223 28.4183 52.8735C42.4468 31.8105 68.4418 18.3434 106.301 11.2504C160.074 1.12176 215.145 -1.12252 271.158 0.459658C317.573 1.78354 362.815 6.21488 406.275 15.8402C440.723 23.4941 464.249 36.9336 477.692 56.442C494.19 80.3544 501.345 105.201 504.578 130.667C508.688 159.506 503.872 188.528 490.346 216.432C485.732 225.233 479.583 233.755 471.989 241.869C459.437 255.711 437.388 263.68 412.589 269.119C375.268 277.457 335.839 282.386 295.778 283.722C273.868 284.403 251.845 285 229.885 285C220.278 285 210.685 284.886 201.116 284.614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationBubble);
export default __webpack_public_path__ + "static/media/RecommendationBubble.0f2be292fda8fc86b07db24caec290e9.svg";
export { ForwardRef as ReactComponent };